import {TheBorderAvalancheWinRunner} from "../general/TheBorderAvalancheWinRunner";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";

/**
 * Created by Jerker Nord on 2022-06-30.
 */

export class TheBorderSuperFSAvalancheWinRunner extends TheBorderAvalancheWinRunner{

    public shouldRun(): boolean {
        return TheBorder.model.gameData.nextMode == TheBorderGameMode.SUPER_FREESPIN_AVALANCHE;
    }
}